import { createSelector } from '@ngrx/store';

import type { User } from '@core/account-types';
import { memoizeSelector } from '@core/ngrx-legacy';
import { StageSelectors } from '@core/offers-data';
import { PlacementSelectors } from '@core/placements-data';

import { CandidateSelectors } from '../candidate/candidate.store';
import { FullCandidateSelectors } from '../full-candidate/full-candidate.store';

const anonymousCandidateStages = memoizeSelector((props: { candidateId: number }) =>
  createSelector(PlacementSelectors.allEntities, StageSelectors.entityMap, (placements, stages) =>
    placements
      .filter(
        placement =>
          placement.candidateId === props.candidateId &&
          stages[placement.stageId]?.candidateAnonymizationEnabled,
      )
      .map(({ stageId }) => stages[stageId]),
  ),
);

const everRevealedFor = memoizeSelector((props: { candidateId: number }) =>
  createSelector(
    FullCandidateSelectors.byIdWithReferences(props.candidateId),
    CandidateSelectors.byIdWithReferences(props.candidateId),
    (fullCandidate, candidate) =>
      (fullCandidate?.everRevealedFor || candidate?.everRevealedFor || <User[]>[]).filter(
        user => user.firstName !== null && user.lastName !== null,
      ),
  ),
);

export const AnonymousCandidateSelectors = {
  stages: anonymousCandidateStages,
  everRevealedFor,
};
